const allowedTags = new Set([
  "A",
  "B",
  "BLOCKQUOTE",
  "BR",
  "DIV",
  "EM",
  "H1",
  "H2",
  "H3",
  "H4",
  "HR",
  "I",
  "LI",
  "OL",
  "P",
  "SPAN",
  "STRONG",
  "SUB",
  "SUP",
  "U",
  "UL",
]);

const allowedAttributes = new Set(["href", "target", "rel"]);

export const sanitizeDocumentHtml = (html = "") => {
  if (!html.trim()) return "";
  const template = window.document.createElement("template");
  template.innerHTML = html;

  const cleanNode = (node: Node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      if (!allowedTags.has(element.tagName)) {
        const text = window.document.createTextNode(element.textContent || "");
        element.replaceWith(text);
        return;
      }

      Array.from(element.attributes).forEach((attribute) => {
        const name = attribute.name.toLowerCase();
        if (name.startsWith("on") || name === "style" || !allowedAttributes.has(name)) {
          element.removeAttribute(attribute.name);
        }
      });

      if (element.tagName === "A") {
        const href = element.getAttribute("href") || "";
        if (!href.startsWith("http://") && !href.startsWith("https://") && !href.startsWith("mailto:")) {
          element.removeAttribute("href");
        }
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noopener noreferrer");
      }
    }

    Array.from(node.childNodes).forEach(cleanNode);
  };

  Array.from(template.content.childNodes).forEach(cleanNode);
  return template.innerHTML;
};

export const richTextToPlainText = (html = "") => {
  if (!html.trim()) return "";
  const template = window.document.createElement("template");
  template.innerHTML = html;
  return (template.content.textContent || "").replace(/\s+/g, " ").trim();
};
